import { Controller } from "@hotwired/stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ["modal", "display", "siteHidden", "siteRadio", "error"]
  static values = { bookingId: Number }

  get modalElement() {
    return this.hasModalTarget ? this.modalTarget : document.getElementById('siteEditModal')
  }

  open(event) {
    event.preventDefault()
    // Clear previous errors
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('d-none')
      this.errorTarget.textContent = ''
    }

    const modalEl = this.modalElement
    if (!modalEl) {
      console.error('Site edit modal not found')
      return
    }

    const bsModal = new Modal(modalEl)
    bsModal.show()
  }

  getCSRFToken() {
    // Versuche zuerst das Meta-Tag
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    if (metaTag) {
      return metaTag.content
    }

    // Fallback: Versuche das Token aus einem Formular zu holen
    const form = document.querySelector('form')
    if (form) {
      const tokenInput = form.querySelector('input[name="authenticity_token"]')
      if (tokenInput) {
        return tokenInput.value
      }
    }

    // Letzter Fallback: Versuche es aus dem document head
    const headToken = document.head.querySelector('meta[name="csrf-token"]')
    if (headToken) {
      return headToken.content
    }

    console.warn('CSRF-Token nicht gefunden')
    return null
  }

  async apply(event) {
    event.preventDefault()
    event.stopPropagation()

    const selectedRadio = this.siteRadioTargets.find(radio => radio.checked)

    if (selectedRadio) {
      const siteId = selectedRadio.value
      const siteName = selectedRadio.dataset.name

      // Persist directly via PATCH request to dedicated route
      const bookingId = this.bookingIdValue
      if (bookingId && Number.isInteger(bookingId) && bookingId > 0) {
        try {
          const csrfToken = this.getCSRFToken()
          const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }

          // Füge CSRF-Token nur hinzu, wenn es vorhanden ist
          // (CSRF-Schutz ist deaktiviert, aber Token kann trotzdem vorhanden sein)
          if (csrfToken) {
            headers['X-CSRF-Token'] = csrfToken
          }

          const response = await fetch(`/bookings/${bookingId}/update_site`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify({ site_id: siteId })
          })

          const data = await response.json()

          if (response.ok) {
            // Success: Update hidden field and display
            if (this.hasSiteHiddenTarget) {
              this.siteHiddenTarget.value = siteId
              // Trigger change event to update availability check
              this.siteHiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
            }
            if (this.hasDisplayTarget) {
              this.displayTarget.innerHTML = `<strong>${siteName}</strong>`
            }

            // Close modal
            const modalEl = this.modalElement
            const bsModal = Modal.getInstance(modalEl)
            if (bsModal) bsModal.hide()
          } else {
            // Error: Show validation errors
            if (this.hasErrorTarget) {
              this.errorTarget.textContent = data.errors.join(', ')
              this.errorTarget.classList.remove('d-none')
            } else {
              alert(data.errors.join('\n'))
            }
          }
        } catch (error) {
          console.error('Error updating site:', error)
          alert('Fehler beim Speichern des Standorts')
        }
      } else {
        // No booking yet (new booking) - just update hidden field and display
        if (this.hasSiteHiddenTarget) {
          this.siteHiddenTarget.value = siteId
        }
        if (this.hasDisplayTarget) {
          this.displayTarget.innerHTML = `<strong>${siteName}</strong>`
        }

        const modalEl = this.modalElement
        const bsModal = Modal.getInstance(modalEl)
        if (bsModal) bsModal.hide()
      }
    }
  }
}
